import splitTypeStep from './Steps/SplitType'
import rodColorStep from './Steps/RodColorStep'
import grommetColor from './Steps/GrommetColorStep'
import trackColorStep from './Steps/TrackColorStep'
import supportTypeStep from './Steps/SupportTypeStep'

export default (
  curtainTemplate,
  curtainParameters,
  curtainType,
  mainFabric,
  railRod,
  withRailRodStep,
  color
) => {
  const curtainSteps = {
    splitTypeStep: splitTypeStep(curtainTemplate, curtainType),
  }
  let extraStep = {};
  if (curtainType === 'ringcurtain') {
    extraStep = { grommetColorStep: grommetColor(curtainTemplate, curtainType) }
  }
  let railRodSteps = {};
  if (withRailRodStep) {
    railRodSteps = {
      rodColorStep: rodColorStep(curtainTemplate, curtainType),
      trackColorStep: trackColorStep(curtainTemplate, curtainType),
      supportTypeStep: supportTypeStep(curtainTemplate, curtainType, color)
    }
  }
  return {
    revision: "0.0.1",
    name: "CurtainFlow",
    showButtons: false,
    autoContinue: true,
    autoSubmit: false,
    hideSubmitButton: true,
    multipleSteps: true,
    steps: {
      ...curtainSteps,
      ...railRodSteps,
      ...extraStep
    }
  }
}
